var r=function(r){return r.scrollTop};export{r as forceReflow};
//# sourceMappingURL=reflow.js.map
